<section id="Section{{index}}" class="newsletter bayadares-before" *ngIf="data">
  <media-attachment *ngIf="data.background" [url]="data.background" [alt]="'Fond newsletter'"></media-attachment>
  <div class="newsletter-container">
    <div class="grid grid-section md-grid-cols-12">
      <div class="col-span-7">
        <div class="newsletter-inner reverse content">
          <div class="h2" *ngIf="data.title" [innerHTML]="data.title|safeHtml"></div>
          <div class="description" *ngIf="data.description" [innerHTML]="data.description|safeHtml"></div>
          <div class="button-container">
            <button class="button" (click)="onNewsletterClick()" i18n="@@NewsletterInscription">Je m'inscris à la newsletter</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
